import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Input,
  TextArea,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox,
  TimeFreeTextBox24
} from 'react-lib/apps/common'

const CardFoodRequestIHUX = (props: any) => {
    return(
      <div>
        <div
          id="CardFoodRequestUX-div-1"
          style={{ height: "50px" }}>
          
          <div
            id="CardFoodRequestUX-div-2"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(4, 1fr)","gridTemplateColumns":"repeat(34, 1fr)"}}>
            <div
              id="CardFoodRequestUX-div-10"
              style={{ gridRow: "2/4", gridColumn: "2/18", fontWeight: "bold", fontSize: "17px", borderBottom: "3px solid grey"}}>
              สั่งอาหาร
            </div>
            <div
              id="CardFoodRequestUX-div-9"
              style={{ gridRow: "2/4", gridColumn: "18/34", fontSize: "17px", borderBottom: "3px solid grey", textAlign: "right"}}>
              {props.status}
            </div>
          </div>
        </div>
        <div
          id="CardFoodRequestUX-div-114"
          style={{ display: "flex" }}>
          
          <div
            id="CardFoodRequestUX-div-11"
            style={{ width: "60%" }}>
            
            <div
              id="CardFoodRequestUX-div-138"
              style={{ margin: "0px 40px 0px 40px" }}>
              
              <Form
                id="CardFoodRequestUX-Form-139">
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-140"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-165"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-167"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-185">
                        ประเภท
                      </label>
                      <label
                        id="CardFoodRequestUX-label-186"
                        style={{ color: "red" }}>
                        *
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-166"
                    style={{ width: "100%"}}>
                    <div
                      id="CardFoodRequestUX-div-168">
                      
                      <Dropdown
                        clearable={true}
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-196"
                        name="type"
                        onChange={props.onChangeData}
                        options={props.typeOptions || []}
                        search={true}
                        selection={true}
                        value={props.FoodRequestSequence?.type || ""}>
                      </Dropdown>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-140"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-165"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-167"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-185">
                        ชนิดอาหาร
                      </label>
                      <label
                        id="CardFoodRequestUX-label-186"
                        style={{ color: "red" }}>
                        *
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-166"
                    style={{ width: "100%"}}>
                    <div
                      id="CardFoodRequestUX-div-168">
                      
                      <Dropdown
                        clearable={true}
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-196"
                        name="food_type"
                        onChange={props.onChangeData}
                        options={props.foodRequestOptions?.foodTypeOptions || []}
                        search={true}
                        selection={true}
                        value={props.FoodRequestSequence?.food_type || ""}>
                      </Dropdown>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-147"
                  inline={true}
                  style={{ display: props.isNPO ? "none" : "" }}>
                  <FormField
                    id="CardFoodRequestUX-FormField-151"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-181"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-195">
                        วันที่
                      </label>
                      <label
                        id="CardFoodRequestUX-label-186"
                        style={{ color: "red" }}>
                        *
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-152"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-182"
                      style={{ display: "flex" }}>
                      
                      <DateTextBox
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        id="CardFoodRequestUX-DateTextBox-201"
                        minDate={props.betoday}
                        onChange={props.onChangeStartDate}
                        style={{ width: "250px" }}
                        value={props.FoodRequestSequence?.start_date || ''}>
                      </DateTextBox>
                      <Checkbox
                        checked={props.FoodRequestSequence?.is_extra_meal}
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        id="CardFoodRequestUX-Checkbox-205"
                        label="มื้อ Extra"
                        name="is_extra_meal"
                        onChange={props.onChangeData}
                        style={{ margin: "10px 0px 0px 50px" }}>
                      </Checkbox>
                      <label
                        id="CardFoodRequestUX-label-206"
                        style={{ color: "red", margin: "10px 0px 0px 0px" } }>
                        *
                      </label>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-218"
                  inline={true}
                  style={{ display: props.foodType !== "R" && "none",  }}>
                  <FormField
                    id="CardFoodRequestUX-FormField-219"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-222">
                      
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-220"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-221">
                      
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-223"
                        multiple={true}
                        name="routine_type"
                        onAddItem={props.onAddOptions}
                        onChange={props.onChangeData}
                        options={props.foodRequestOptions?.routineTypeOptions || []}
                        search={true}
                        selection={true}
                        value={props.FoodRequestSequence?.routine_type || []}>
                      </Dropdown>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-142"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-161"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-171"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-189">
                        มื้ออาหาร
                      </label>
                      <label
                        id="CardFoodRequestUX-label-190"
                        style={{ color: "red" }}>
                        *
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-162"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-172">
                      
                      <div
                        id="CardFoodRequestUX-div-208"
                        style={{ display: props.foodType === "R" ? "none" : "" }  }>
                        {props.generalTimeComponent}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-209"
                        style={{ display: props.foodType === "R" ? "" : "none" }  }>
                        
                        <Dropdown
                          clearable={true}
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Dropdown-210"
                          multiple={true}
                          name="routine_time"
                          onChange={props.onChangeRoutineTime}
                          options={props.foodRequestOptions?.routineTimeOptions || []}
                          search={true}
                          selection={true}
                          value={props.FoodRequestSequence?.routine_time || []}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-147"
                  inline={true}
                  style={{ display: props.isNPO ? "" : "none" }}>
                  <FormField
                    id="CardFoodRequestUX-FormField-151"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-181"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-195">
                        วันที่เริ่ม NPO
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-152"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-182"
                      style={{ display: "flex" }}>
                      
                      <DateTextBox
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        id="CardFoodRequestUX-DateTextBox-201"
                        minDate={props.betoday}
                        onChange={props.onChangeStartDate}
                        style={{ width: "100%" }}
                        value={props.FoodRequestSequence?.start_date || ''}>
                      </DateTextBox>
                      <TimeFreeTextBox24
                        className="time-custom-react-picker"
                        disabled={true}
                        id="CardFoodRequestUX-TimeFreeTextBox24-265"
                        value={props.start_time || ''}>
                      </TimeFreeTextBox24>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-147"
                  inline={true}
                  style={{ display: props.isNPO && props.FoodRequestSequence?.type === "CONTINUE" ? "" : "none" }}>
                  <FormField
                    id="CardFoodRequestUX-FormField-151"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-181"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-195">
                        วันที่สิ้นสุด NPO
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-152"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-182"
                      style={{ display: "flex" }}>
                      
                      <DateTextBox
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        id="CardFoodRequestUX-DateTextBox-201"
                        minDate={props.betoday}
                        onChange={props.onChangeNPODate}
                        style={{ width: "100%" }}
                        value={props.FoodRequestSequence?.npo_date || ''}>
                      </DateTextBox>
                      <TimeFreeTextBox24
                        className="time-custom-react-picker"
                        disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                        id="CardFoodRequestUX-TimeFreeTextBox24-265"
                        onChange={props.onChangeNPOTime}
                        value={props.FoodRequestSequence?.npo_time || ""}>
                      </TimeFreeTextBox24>
                    </div>
                  </FormField>
                </FormGroup>
                <div
                  id="CardFoodRequestUX-div-224"
                  style={{ display: props.foodType === "R" ? "" : "none",  }}>
                  
                  <FormGroup
                    id="CardFoodRequestUX-FormGroup-225"
                    inline={true}>
                    <FormField
                      id="CardFoodRequestUX-FormField-228"
                      width={3}>
                      <div
                        id="CardFoodRequestUX-div-238"
                        style={{ fontWeight: "bold" }}>
                        
                        <label
                          id="CardFoodRequestUX-label-248">
                          ปริมาตร
                        </label>
                        <label
                          id="CardFoodRequestUX-label-249"
                          style={{ color: "red" }}>
                          *
                        </label>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-229"
                      style={{ width: "100%"}}
                      width={7}>
                      <div
                        id="CardFoodRequestUX-div-239"
                        style={{ display: "flex", width: "100%", margin: "0px 0px 0px 10px" }}>
                        
                        <Input
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Input-257"
                          name="routine_size"
                          onChange={props.onChangeData}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          type="number"
                          value={props.FoodRequestSequence?.routine_size || ""}>
                        </Input>
                        <Dropdown
                          clearable={true}
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Dropdown-258"
                          name="routine_unit"
                          onChange={props.onChangeData}
                          options={props.foodRequestOptions?.routineUnitOptions || []}
                          search={true}
                          selection={true}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          value={props.FoodRequestSequence?.routine_unit || ""}>
                        </Dropdown>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-230"
                      width={3}>
                      <div
                        id="CardFoodRequestUX-div-240"
                        style={{ fontWeight: "bold", justifyContent: "right", display: "flex", width: "100%" }}>
                        
                        <label
                          id="CardFoodRequestUX-label-256">
                          ความเข้มข้น
                        </label>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-231"
                      style={{ width: "100%"}}
                      width={7}>
                      <div
                        id="CardFoodRequestUX-div-241"
                        style={{ display: "flex", width: "100%" }}>
                        
                        <Input
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Input-259"
                          name="intensity"
                          onChange={props.onChangeData}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          type="number"
                          value={props.FoodRequestSequence?.intensity || ""}>
                        </Input>
                        <Dropdown
                          clearable={true}
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Dropdown-260"
                          name="intensity_unit"
                          onChange={props.onChangeData}
                          options={props.foodRequestOptions?.intensityUnitOptions || []}
                          search={true}
                          selection={true}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          value={props.FoodRequestSequence?.intensity_unit || ""}>
                        </Dropdown>
                      </div>
                    </FormField>
                  </FormGroup>
                  <FormGroup
                    id="CardFoodRequestUX-FormGroup-226"
                    inline={true}>
                    <FormField
                      id="CardFoodRequestUX-FormField-232"
                      width={3}>
                      <div
                        id="CardFoodRequestUX-div-242"
                        style={{ fontWeight: "bold" }}>
                        
                        <label
                          id="CardFoodRequestUX-label-250">
                          Mixture
                        </label>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-233"
                      style={{ width: "100%"}}
                      width={7}>
                      <div
                        id="CardFoodRequestUX-div-243"
                        style={{ display: "flex", width: "100%", margin: "0px 0px 0px 10px" }}>
                        
                        <Dropdown
                          allowAdditions={true}
                          clearable={true}
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Dropdown-253"
                          multiple={true}
                          name="mixture"
                          onAddItem={props.onAddOptions}
                          onChange={props.onChangeData}
                          options={props.foodRequestOptions?.mixtureOptions || []}
                          search={true}
                          selection={true}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          value={props.FoodRequestSequence?.mixture || []}>
                        </Dropdown>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-234"
                      width={3}>
                      <div
                        id="CardFoodRequestUX-div-244"
                        style={{ fontWeight: "bold", justifyContent: "right", display: "flex", width: "100%" }}>
                        
                        <label
                          id="CardFoodRequestUX-label-255">
                          Volume
                        </label>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-235"
                      style={{ width: "100%"}}
                      width={7}>
                      <div
                        id="CardFoodRequestUX-div-245"
                        style={{ width: "100%" }}>
                        
                        <Input
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Input-254"
                          name="mixture_volume"
                          onChange={props.onChangeData}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          value={props.FoodRequestSequence?.mixture_volume || ""}>
                        </Input>
                      </div>
                    </FormField>
                  </FormGroup>
                  <FormGroup
                    id="CardFoodRequestUX-FormGroup-227"
                    inline={true}>
                    <FormField
                      id="CardFoodRequestUX-FormField-236"
                      width={3}>
                      <div
                        id="CardFoodRequestUX-div-246"
                        style={{ fontWeight: "bold" }}>
                        
                        <label
                          id="CardFoodRequestUX-label-251">
                          หมายเหตุ Mixture
                        </label>
                      </div>
                    </FormField>
                    <FormField
                      id="CardFoodRequestUX-FormField-237"
                      style={{ width: "100%"}}>
                      <div
                        id="CardFoodRequestUX-div-247">
                        
                        <Input
                          disabled={props.formReadOnly || !!props.FoodRequestSequence?.id}
                          fluid={true}
                          id="CardFoodRequestUX-Input-252"
                          name="mixture_remark"
                          onChange={props.onChangeData}
                          style={{ display: props.foodType === "R" ? "" : "none" }}
                          value={props.FoodRequestSequence?.mixture_remark || ""}>
                        </Input>
                      </div>
                    </FormField>
                  </FormGroup>
                </div>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-143"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-159"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-173"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-191">
                        เสริม
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-160"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-174">
                      
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        disabled={props.formReadOnly || props.isNPO}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-197"
                        multiple={true}
                        name="supplement_food"
                        onAddItem={props.onAddOptions}
                        onChange={props.onChangeData}
                        options={props.foodRequestOptions?.supplementFoodOptions || []}
                        search={true}
                        selection={true}
                        value={props.FoodRequestSequence?.supplement_food || []}>
                      </Dropdown>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-144"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-157"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-175"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-192">
                        แพ้
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-158"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-176">
                      
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        disabled={props.formReadOnly}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-217"
                        multiple={true}
                        name="allergy_food"
                        onAddItem={props.onAddOptions}
                        onChange={props.onChangeData}
                        options={props.foodRequestOptions?.allergyFoodOptions || []}
                        search={true}
                        selection={true}
                        style={{ display: "none" }}
                        value={props.FoodRequestSequence?.allergy_food || []}>
                      </Dropdown>
                      <Input
                        disabled={props.isNPO}
                        fluid={true}
                        id="CardFoodRequestUX-Input-199"
                        readOnly={true}
                        value={props.allergyFood}>
                      </Input>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-145"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-155"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-177"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-193">
                        ข้อจำกัด
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-156"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-178">
                      
                      <Dropdown
                        allowAdditions={true}
                        clearable={true}
                        disabled={props.formReadOnly || props.isNPO}
                        fluid={true}
                        id="CardFoodRequestUX-Dropdown-198"
                        multiple={true}
                        name="restriction_food"
                        onAddItem={props.onAddOptions}
                        onChange={props.onChangeData}
                        options={props.foodRequestOptions?.restrictionFoodOptions || []}
                        search={true}
                        selection={true}
                        value={props.FoodRequestSequence?.restriction_food || []}>
                      </Dropdown>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-146"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-153"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-179"
                      style={{ fontWeight: "bold" }}>
                      
                      <label
                        id="CardFoodRequestUX-label-194">
                        หมายเหตุ
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-154"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-180">
                      
                      <TextArea
                        disabled={props.formReadOnly}
                        id="CardFoodRequestUX-TextArea-200"
                        name="remark"
                        onChange={props.onChangeData}
                        value={props.FoodRequestSequence?.remark || ""}>
                      </TextArea>
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardFoodRequestUX-FormGroup-148"
                  inline={true}>
                  <FormField
                    id="CardFoodRequestUX-FormField-149"
                    width={3}>
                    <div
                      id="CardFoodRequestUX-div-183">
                      
                    </div>
                  </FormField>
                  <FormField
                    id="CardFoodRequestUX-FormField-150"
                    style={{ width: "100%" }}>
                    <div
                      id="CardFoodRequestUX-div-184"
                      style={{ display: "flex" }}>
                      
                      <div
                        id="CardFoodRequestUX-div-211">
                        {props.buttonSave}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-212">
                        {props.buttonResume}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-213">
                        {props.buttonNPO}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-214">
                        {props.buttonOff}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-215">
                        {props.buttonRenew}
                      </div>
                      <div
                        id="CardFoodRequestUX-div-216">
                        {props.buttonClear}
                      </div>
                    </div>
                  </FormField>
                </FormGroup>
              </Form>
            </div>
          </div>
          <div
            id="CardFoodRequestUX-div-115"
            style={{ width: "40%", paddingRight: "40px" }}>
            
            <div
              id="CardFoodRequestUX-div-116">
              {props.specialDiet}
            </div>
            <div
              id="CardFoodRequestUX-div-117">
              {props.nutrition}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardFoodRequestIHUX

export const screenPropsDefault = {}

/* Date Time : Wed Mar 19 2025 12:37:24 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "label": "divgrid",
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(4, 1fr)\",\"gridTemplateColumns\":\"repeat(34, 1fr)\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/4\", gridColumn: \"18/34\", fontSize: \"17px\", borderBottom: \"3px solid grey\", textAlign: \"right\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "สั่งอาหาร"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/4\", gridColumn: \"2/18\", fontWeight: \"bold\", fontSize: \"17px\", borderBottom: \"3px solid grey\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"40%\", paddingRight: \"40px\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 115,
      "props": {
        "children": {
          "type": "code",
          "value": "props.specialDiet"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-116"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 115,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nutrition"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-117"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 40px 0px 40px\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "Form",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Form-139"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isNPO ? \"\" : \"none\" }"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormField",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-149"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-150"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 147,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-151"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "FormField",
      "parent": 147,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-152"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-153"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-154"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 145,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 145,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-156"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 144,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-157"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 144,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-158"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-159"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-160"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-161"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-162"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-165"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-166"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-168"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-172"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-174"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-176"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-178"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-179"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-180"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "ชนิดอาหาร"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-185"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-186"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "มื้ออาหาร"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-189"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-190"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "label",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": "เสริม"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-191"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": "แพ้"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-192"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "label",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อจำกัด"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-193"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "label",
      "parent": 179,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-194"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "label",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่ม NPO"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-195"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "Dropdown",
      "parent": 168,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-196"
        },
        "name": {
          "type": "value",
          "value": "food_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.foodTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.food_type || \"\""
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Dropdown",
      "parent": 174,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || props.isNPO"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-197"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "supplement_food"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.supplementFoodOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.supplement_food || []"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Dropdown",
      "parent": 178,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || props.isNPO"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-198"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "restriction_food"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.restrictionFoodOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.restriction_food || []"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "Input",
      "parent": 176,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isNPO"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Input-199"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.allergyFood"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "TextArea",
      "parent": 180,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-TextArea-200"
        },
        "name": {
          "type": "value",
          "value": "remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.remark || \"\""
        }
      },
      "seq": 200,
      "void": true
    },
    {
      "from": "react-lib/apps/common",
      "id": 201,
      "name": "DateTextBox",
      "parent": 182,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-DateTextBox-201"
        },
        "minDate": {
          "type": "code",
          "value": "props.betoday"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.start_date || ''"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 208,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generalTimeComponent"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-208"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"none\" : \"\" }  "
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-209"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }  "
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "Dropdown",
      "parent": 209,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-210"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "routine_time"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRoutineTime"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.routineTimeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.routine_time || []"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": null,
      "id": 211,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-211"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonResume"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-212"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonNPO"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-213"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonOff"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-214"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRenew"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-215"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonClear"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-216"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "Dropdown",
      "parent": 176,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-217"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "allergy_food"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.allergyFoodOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.allergy_food || []"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-218"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType !== \"R\" && \"none\",  }"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "FormField",
      "parent": 218,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-219"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "FormField",
      "parent": 218,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-220"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "div",
      "parent": 220,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-221"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": null,
      "id": 222,
      "name": "div",
      "parent": 219,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-222"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "Dropdown",
      "parent": 221,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-223"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "routine_type"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.routineTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.routine_type || []"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-224"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\",  }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "FormGroup",
      "parent": 224,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-225"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "FormGroup",
      "parent": 224,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-226"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormGroup",
      "parent": 224,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-227"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-228"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-229"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-230"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-231"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-232"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-233"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-234"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-235"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-236"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-237"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "div",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-238"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-239"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", margin: \"0px 0px 0px 10px\" }"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-240"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", justifyContent: \"right\", display: \"flex\", width: \"100%\" }"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 231,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-241"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\" }"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 232,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-242"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-243"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", margin: \"0px 0px 0px 10px\" }"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 234,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-244"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", justifyContent: \"right\", display: \"flex\", width: \"100%\" }"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-247"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "label",
      "parent": 238,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาตร"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-248"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "label",
      "parent": 238,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-249"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "label",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "Mixture"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-250"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "label",
      "parent": 246,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ Mixture"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-251"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 252,
      "name": "Input",
      "parent": 247,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Input-252"
        },
        "name": {
          "type": "value",
          "value": "mixture_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.mixture_remark || \"\""
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 253,
      "name": "Dropdown",
      "parent": 243,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-253"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "mixture"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.mixtureOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.mixture || []"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 254,
      "name": "Input",
      "parent": 245,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Input-254"
        },
        "name": {
          "type": "value",
          "value": "mixture_volume"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.mixture_volume || \"\""
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "label",
      "parent": 244,
      "props": {
        "children": {
          "type": "value",
          "value": "Volume"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-255"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "label",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเข้มข้น"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-256"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "Input",
      "parent": 239,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Input-257"
        },
        "name": {
          "type": "value",
          "value": "routine_size"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.routine_size || \"\""
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "Dropdown",
      "parent": 239,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-258"
        },
        "name": {
          "type": "value",
          "value": "routine_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.routineUnitOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.routine_unit || \"\""
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 259,
      "name": "Input",
      "parent": 241,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Input-259"
        },
        "name": {
          "type": "value",
          "value": "intensity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.intensity || \"\""
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 260,
      "name": "Dropdown",
      "parent": 241,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-260"
        },
        "name": {
          "type": "value",
          "value": "intensity_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.foodRequestOptions?.intensityUnitOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.foodType === \"R\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.intensity_unit || \"\""
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 267,
      "name": "FormField",
      "parent": 266,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-165"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "div",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "label",
      "parent": 268,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-185"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 270,
      "name": "label",
      "parent": 268,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-186"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 271,
      "name": "FormField",
      "parent": 266,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-166"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-168"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 273,
      "name": "Dropdown",
      "parent": 272,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Dropdown-196"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.type || \"\""
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isNPO ? \"none\" : \"\" }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 275,
      "name": "FormField",
      "parent": 274,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-151"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "label",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-195"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 278,
      "name": "FormField",
      "parent": 274,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-152"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "div",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 280,
      "name": "DateTextBox",
      "parent": 279,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-DateTextBox-201"
        },
        "minDate": {
          "type": "code",
          "value": "props.betoday"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"250px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.start_date || ''"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "label",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-186"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "Checkbox",
      "parent": 279,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.FoodRequestSequence?.is_extra_meal"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-Checkbox-205"
        },
        "label": {
          "type": "value",
          "value": "มื้อ Extra"
        },
        "name": {
          "type": "value",
          "value": "is_extra_meal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 0px 0px 50px\" }"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 284,
      "name": "label",
      "parent": 279,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-206"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\", margin: \"10px 0px 0px 0px\" } "
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormGroup-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isNPO && props.FoodRequestSequence?.type === \"CONTINUE\" ? \"\" : \"none\" }"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 286,
      "name": "FormField",
      "parent": 285,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-151"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "div",
      "parent": 286,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "label",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สิ้นสุด NPO"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-label-195"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 289,
      "name": "FormField",
      "parent": 285,
      "props": {
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-FormField-152"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 289,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 291,
      "name": "DateTextBox",
      "parent": 290,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-DateTextBox-201"
        },
        "minDate": {
          "type": "code",
          "value": "props.betoday"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNPODate"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.npo_date || ''"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 292,
      "name": "TimeFreeTextBox24",
      "parent": 290,
      "props": {
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "disabled": {
          "type": "code",
          "value": "props.formReadOnly || !!props.FoodRequestSequence?.id"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-TimeFreeTextBox24-265"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNPOTime"
        },
        "value": {
          "type": "code",
          "value": "props.FoodRequestSequence?.npo_time || \"\""
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 296,
      "name": "TimeFreeTextBox24",
      "parent": 182,
      "props": {
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardFoodRequestUX-TimeFreeTextBox24-265"
        },
        "onChange": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.start_time || ''"
        }
      },
      "seq": 296,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardFoodRequestIHUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
